// extracted by mini-css-extract-plugin
export default {"region":"Region_region__qYypl","regionTitle":"Region_regionTitle__JDLi1","countryList":"Region_countryList__HfhIg"};